module.exports = __webpack_public_path__ + "static/dots-icon-4d618404dd58ab012f26861159285d9f.svg";